import { ACCELERATOR_MODULES, MODULE_PROMPTS } from "../constants/modules";
import { parseOutputs } from "./messages";

/* ── What Brill can see in an Accelerator module ─────────────────────────────
 *
 * THE BUG THIS EXISTS FOR (2026-08-27). A live client opened My Mission with
 * all five sections ticked and the panel reading 100%, and Brill said:
 *
 *   "I don't actually have the locked content for The One Problem, Who You're
 *    For, and The Transformation Promise from this conversation ... those three
 *    foundational prompts haven't been run yet IN WHAT I CAN SEE."
 *
 * Brill was not confused — it was being exact. An Accelerator chat was only ever
 * given the transcript and her niche. Momentum panels get their locked record
 * injected and Ideation gets the Decoder's, but a module was never given its
 * own sections, because normally they are in the transcript already: they were
 * written there.
 *
 * Hers were not. Her sections were recovered and refiled into `outputs` under
 * the module that owns them, while the CONVERSATIONS that produced them stayed
 * in whichever chat they actually happened in. So `outputs` held the work and
 * the module's transcript did not, and the two readers disagreed again — the
 * sidebar reading storage and saying done, Brill reading the transcript and
 * asking her to paste it all back in.
 *
 * ONLY WHAT THE TRANSCRIPT IS MISSING. In the ordinary case this returns null
 * and adds nothing at all, which is the point: it costs tokens on exactly the
 * conversations that are currently broken, and nothing on the rest. Sending
 * every locked section every turn would double the prompt to fix a case that
 * hardly ever happens.
 *
 * Stale sections are included rather than hidden. `buildNicheContext` already
 * names which ones were built under a niche she has left, so Brill is told what
 * it is looking at — and a stale section is the work to revise, not an absence.
 */
export function buildAcceleratorContext({ moduleId, savedOutputs, messages }) {
  if (!ACCELERATOR_MODULES.includes(moduleId)) return null;
  const saved = savedOutputs || {};

  /* The module's own order, plus anything stored under it that the list has
     never heard of — Brill invents section names, and an invented one is real
     locked work rather than a mistake. */
  const order = MODULE_PROMPTS[moduleId] || [];
  const names = [...order, ...Object.keys(saved).filter((n) => !order.includes(n))];

  const written = parseOutputs(Array.isArray(messages) ? messages : []);
  const absent = names.filter((n) => saved[n] && written[n] == null);
  if (!absent.length) return null;

  const body = absent.map((n) => `--- ${n} ---\n${String(saved[n]).trim()}`).join("\n\n");
  return "[LOCKED_SECTIONS — read only, do not reference as a conversation]\n"
    + "These sections of this module are already locked and saved. They were "
    + "written in an earlier conversation, so they are not in the messages "
    + "below — but they exist, they are hers, and they are current. Treat them "
    + "as done. Do not ask her to paste them in, do not re-run their questions, "
    + "and build on them where the module calls for it.\n\n"
    + body;
}
